import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import 'rxjs/add/observable/throw';

import { BaseWebService } from './../../services/base-web.service';

@Injectable()
export class ContractSignedService {
    constructor(
        private _basewebservice: BaseWebService
    ) {
    }

    /**
     * Function to download docusign.
     * @param  {any} id contains treatment history id.
     */
    downloadDocusign(id: any) {
        return this._basewebservice.requestBlob("v1/docusign_document_download/" + id + "/", "get")
            .map(res => res)
            .catch(this.handleError);
    }

    handleError(error: Response | any) {
        return Observable.throw(error);
    }

}
